import React, { useEffect, lazy } from 'react';
import { useForm } from 'react-hook-form';
import { ModalHeader, ModalBody, ModalFooter, Button, Row, Col } from 'reactstrap';
import 'react-datetime/css/react-datetime.css';
import { useTranslation } from 'react-i18next';
import FormTextArea from '../ReactHookFormCustom/FormTextArea';
import FormInput from '../ReactHookFormCustom/FormInput';
import UserInfoSimple from '../shared/userInfoSimple';
import { sendEmail } from '../../Services/emailService';

const Modal = lazy(() => import('reactstrap/lib/Modal'));

const SendEmailModal = ({ isEmailModalOpen, toggleIsEmailModalOpen, sender, recipient }) => {
  const { t } = useTranslation();

  const initialValues = {};

  const { handleSubmit, reset, control } = useForm({
    defaultValues: initialValues,
  });

  useEffect(() => {
    reset();
  }, [isEmailModalOpen]);

  const composeEmail = (emailSubject, emailContent, address) => {
    sendEmail({ subject: emailSubject, content: emailContent, address });
  };

  const handleValidSubmit = (data) => {
    composeEmail(data.emailSubject, data.emailContent, recipient.email);
    toggleIsEmailModalOpen();
  };

  return (
    <Modal isOpen={isEmailModalOpen} centered>
      <ModalHeader>
        <h3 className="d-flex align-items-center">
          <i className="fa icon-envelope mr-2" />
          {t('email.NEW_EMAIL')}
        </h3>
      </ModalHeader>
      <form onSubmit={handleSubmit(handleValidSubmit)}>
        <ModalBody>
          <Row>
            <Col xs={12} sm={6} className="text-truncate pb-2 mb-2">
              <label>{t('email.SENDER')}:</label>
              <div>
                <UserInfoSimple name={sender?.name} lastName={sender?.lastName} email={sender?.email} />
              </div>
            </Col>
            <Col xs={12} sm={6} className="text-truncate pb-2 mb-2">
              <label>{t('email.RECEIVER')}:</label>
              <div>
                <UserInfoSimple name={recipient?.name} lastName={recipient?.lastName} email={recipient?.email} />
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormInput
                control={control}
                name="emailSubject"
                id="emailSubjectId"
                label={t('kanban.SUBJECT')}
                rules={{ required: t('common.REQUIRED') }}
              />
            </Col>
          </Row>
          <Row className="pt-2">
            <Col>
              <FormTextArea
                control={control}
                name="emailContent"
                id="emailContentId"
                label={t('email.CONTENT')}
                maxLength={1000}
                rules={{ required: t('common.REQUIRED') }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary">{t('email.SEND')}</Button>
          <Button color="secondary" onClick={toggleIsEmailModalOpen}>
            {t('common.CANCEL')}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default SendEmailModal;
